import React from "react";
import { Badge, Card } from "@shared/ui/components";
import { Check, X } from "lucide-react";

const features = [
  {
    category: "Лимиты транскрибации",
    items: [
      { name: "Минуты в месяц", perMinute: "150", basic: "450", pro: "2000" },
      { name: "Докупка минут", perMinute: "Недоступно", basic: "Доступна", pro: "Доступна" },
      { name: "Максимальный размер файла", perMinute: "2 ГБ", basic: "2 ГБ", pro: "2 ГБ" }
    ]
  },
  {
    category: "Возможности",
    items: [
      { name: "Распознавание спикеров", perMinute: true, basic: true, pro: true },
      { name: "AI краткое содержание", perMinute: "5 в месяц", basic: "25 в месяц", pro: "50 в месяц" },
      { name: "Приоритет обработки", perMinute: "Высокий", basic: "Высокий", pro: "Наивысший" },
      { name: "Временные метки", perMinute: true, basic: true, pro: true }
    ]
  },
  {
    category: "Форматы экспорта",
    items: [
      { name: "TXT формат", perMinute: true, basic: true, pro: true },
      { name: "SRT формат", perMinute: true, basic: true, pro: true },
      { name: "DOCX формат", perMinute: true, basic: true, pro: true }
    ]
  },
  {
    category: "Дополнительные возможности",
    items: [
      { name: "Сохранение истории", perMinute: true, basic: true, pro: true },
      { name: "Редактирование транскрипций", perMinute: true, basic: true, pro: true }
    ]
  },
  {
    category: "Поддержка",
    items: [{ name: "Тип поддержки", perMinute: "Приоритетная", basic: "Приоритетная", pro: "Приоритетная" }]
  }
];

export function PricingComparison(): JSX.Element {
  const renderValue = (value: string | boolean): JSX.Element => {
    if (typeof value === "boolean") {
      return value ? (
        <Check className="h-3 w-3 sm:h-4 sm:w-4 md:h-5 md:w-5 text-green-600 mx-auto" />
      ) : (
        <X className="h-3 w-3 sm:h-4 sm:w-4 md:h-5 md:w-5 text-muted-foreground mx-auto" />
      );
    }

    if (value === "Скоро") {
      return (
        <Badge variant="outline" className="text-[9px] sm:text-xs mx-auto">
          Скоро
        </Badge>
      );
    }

    return <span className="text-[9px] sm:text-xs md:text-sm text-foreground leading-tight">{value}</span>;
  };

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-muted/30">
      <div className="container px-4">
        <div className="mx-auto max-w-5xl">
          <div className="mb-8 md:mb-12 text-center">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-2 md:mb-3">
              Сравнение всех возможностей
            </h2>
            <p className="text-base md:text-lg text-muted-foreground">Посмотрите, что включено в каждый тариф</p>
          </div>

          <Card className="overflow-hidden">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border bg-muted/50">
                  <th className="text-left p-2 md:p-4 font-semibold text-foreground text-[10px] sm:text-xs md:text-sm">
                    Возможность
                  </th>
                  <th className="text-center p-1 md:p-4 font-semibold text-foreground text-[10px] sm:text-xs md:text-sm">
                    Пробный
                  </th>
                  <th className="text-center p-1 md:p-4 font-semibold text-foreground text-[10px] sm:text-xs md:text-sm">
                    Базовый
                  </th>
                  <th className="text-center p-1 md:p-4 font-semibold text-foreground text-[10px] sm:text-xs md:text-sm">
                    Профи
                  </th>
                </tr>
              </thead>
              <tbody>
                {features.map(category => (
                  <React.Fragment key={category.category}>
                    <tr className="border-b border-border bg-muted/30">
                      <td
                        colSpan={4}
                        className="p-2 md:p-4 font-semibold text-foreground text-[10px] sm:text-xs md:text-sm"
                      >
                        {category.category}
                      </td>
                    </tr>
                    {category.items.map((item, index) => (
                      <tr key={item.name} className={index % 2 === 0 ? "bg-background" : "bg-muted/20"}>
                        <td className="p-1.5 md:p-4 text-[9px] sm:text-xs md:text-sm text-muted-foreground">
                          {item.name}
                        </td>
                        <td className="p-1 md:p-4 text-center">{renderValue(item.perMinute)}</td>
                        <td className="p-1 md:p-4 text-center">{renderValue(item.basic)}</td>
                        <td className="p-1 md:p-4 text-center">{renderValue(item.pro)}</td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </Card>
        </div>
      </div>
    </section>
  );
}